import { render, staticRenderFns } from "./StaffBonusTable.vue?vue&type=template&id=086c51c8&scoped=true"
import script from "./StaffBonusTable.vue?vue&type=script&lang=js"
export * from "./StaffBonusTable.vue?vue&type=script&lang=js"
import style0 from "./StaffBonusTable.vue?vue&type=style&index=0&id=086c51c8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c51c8",
  null
  
)

export default component.exports